import {Component} from '@wonderlandengine/api';
import {Puzzle} from './puzzle.js';
import {quat} from 'gl-matrix';
import {Mathf} from '../utils/Mathf.js';

const tempQuat = quat.create();
/**
 * Bit of a fake billboard to rotate an object based on the camera angle.
 */
export class Billboard extends Component {
    static TypeName = 'billboard';

    update(dt: number) {
        let q = quat.identity(tempQuat);
        quat.rotateY(q, q, (Puzzle.instance.mainCamera.angle + 180) * Mathf.Deg2Rad);
        this.object.setRotationWorld(q);
    }
}
